import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "../../../geometry.js";
import { isSome as t, filterNones as r } from "../../../core/maybe.js";
import { a as e } from "../../../chunks/mat2d.js";
import { c as s, a } from "../../../chunks/mat2df64.js";
import { r as o, i as n } from "../../../chunks/quat.js";
import { a as i } from "../../../chunks/quatf64.js";
import { a as l, d as h, f as m, n as c, c as f, q as d } from "../../../chunks/vec3.js";
import { c as p } from "../../../chunks/vec3f64.js";
import u from "../../../geometry/Point.js";

function w(r, e) {
  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return t(s) ? [r, e, s] : [r, e];
}

function g(r, e) {
  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return t(s) ? {
    x: r,
    y: e,
    z: s
  } : {
    x: r,
    y: e
  };
}

var R = /*#__PURE__*/function () {
  function R(t) {
    _classCallCheck(this, R);

    this.spatialReference = t;
  }

  _createClass(R, [{
    key: "mapToLocalMultiple",
    value: function mapToLocalMultiple(t) {
      var _this = this;

      return r(t.map(function (t) {
        return _this.mapToLocal(t);
      }));
    }
  }, {
    key: "doUnnormalization",
    get: function get() {
      return !1;
    }
  }]);

  return R;
}();

var W = /*#__PURE__*/function (_R) {
  _inherits(W, _R);

  var _super = _createSuper(W);

  function W(t, r) {
    var _this2;

    var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, W);

    _this2 = _super.call(this, r), _this2.defaultZ = o, _this2.transform = s(), _this2.transformInv = s(), _this2.transform = a(t), e(_this2.transformInv, _this2.transform);
    return _this2;
  }

  _createClass(W, [{
    key: "makeMapPoint",
    value: function makeMapPoint(t, r) {
      return w(t, r, this.defaultZ);
    }
  }, {
    key: "mapToLocal",
    value: function mapToLocal(t) {
      return g(this.transform[0] * t[0] + this.transform[2] * t[1] + this.transform[4], this.transform[1] * t[0] + this.transform[3] * t[1] + this.transform[5]);
    }
  }, {
    key: "localToMap",
    value: function localToMap(t) {
      return w(this.transformInv[0] * t.x + this.transformInv[2] * t.y + this.transformInv[4], this.transformInv[1] * t.x + this.transformInv[3] * t.y + this.transformInv[5], this.defaultZ);
    }
  }]);

  return W;
}(R);

var v = /*#__PURE__*/function (_R2) {
  _inherits(v, _R2);

  var _super2 = _createSuper(v);

  function v(t, r) {
    var _this3;

    _classCallCheck(this, v);

    _this3 = _super2.call(this, t.spatialReference), _this3.view = t, _this3.defaultZ = null, _this3.pWS = p(), _this3.tangentFrameUpWS = p(), _this3.tangentFrameRightWS = p(), _this3.tangentFrameForwardWS = p(), _this3.localFrameRightWS = p(), _this3.localFrameUpWS = p(), _this3.worldToLocalTransform = i(), _this3.localToWorldTransform = i(), _this3.scale = 1, _this3.scale = t.resolution, _this3.referenceMapPoint = r, _this3.defaultZ = r.hasZ ? r.z : null;
    var e = t.state.camera.viewRight;
    _this3.view.renderCoordsHelper.toRenderCoords(_this3.referenceMapPoint, _this3.pWS), _this3.view.renderCoordsHelper.worldBasisAtPosition(_this3.pWS, 0, _this3.tangentFrameRightWS), _this3.view.renderCoordsHelper.worldBasisAtPosition(_this3.pWS, 1, _this3.tangentFrameUpWS), _this3.view.renderCoordsHelper.worldBasisAtPosition(_this3.pWS, 2, _this3.tangentFrameForwardWS);
    var s = p();
    l(s, _this3.tangentFrameForwardWS, h(e, _this3.tangentFrameForwardWS)), m(_this3.localFrameRightWS, e, s), c(_this3.localFrameRightWS, _this3.localFrameRightWS), f(_this3.localFrameUpWS, _this3.tangentFrameForwardWS, _this3.localFrameRightWS), o(_this3.worldToLocalTransform, _this3.localFrameRightWS, _this3.tangentFrameRightWS), n(_this3.localToWorldTransform, _this3.worldToLocalTransform);
    return _this3;
  }

  _createClass(v, [{
    key: "doUnnormalization",
    get: function get() {
      return "global" === this.view.viewingMode;
    }
  }, {
    key: "makeMapPoint",
    value: function makeMapPoint(t, r) {
      return w(t, r, this.defaultZ);
    }
  }, {
    key: "mapToLocal",
    value: function mapToLocal(r) {
      var e = p();
      this.view.renderCoordsHelper.toRenderCoords(new u({
        x: r[0],
        y: r[1],
        spatialReference: this.spatialReference
      }), e), d(e, e, this.worldToLocalTransform);
      var s = this.view.renderCoordsHelper.fromRenderCoords(e, this.view.spatialReference);
      return t(s) ? g(s.x / this.scale, s.y / this.scale) : null;
    }
  }, {
    key: "localToMap",
    value: function localToMap(r) {
      var e = p();
      this.view.renderCoordsHelper.toRenderCoords(new u({
        x: r.x * this.scale,
        y: r.y * this.scale,
        spatialReference: this.spatialReference
      }), e), d(e, e, this.localToWorldTransform);
      var s = this.view.renderCoordsHelper.fromRenderCoords(e, this.view.spatialReference);
      return t(s) ? w(s.x, s.y, this.defaultZ) : null;
    }
  }]);

  return v;
}(R);

function F(t, r) {
  if ("2d" === t.type) return new W(t.state.transform, t.spatialReference, r.length > 2 ? r[2] : null);

  if ("3d" === t.type) {
    var _e = r.length > 2 ? new u({
      x: r[0],
      y: r[1],
      z: r[2],
      spatialReference: t.spatialReference
    }) : new u({
      x: r[0],
      y: r[1],
      spatialReference: t.spatialReference
    });

    return new v(t, _e);
  }

  return null;
}

export { W as AffineCoordinateSystem, v as SceneViewCoordinateSystem, R as SurfaceCoordinateSystem, F as createViewAlignedCoordinateSystem, w as makeMapPoint, g as makeSurfacePoint };